import { useQuery } from '@tanstack/react-query';
import api from '../api/client';
import { RelatorioVendasResponse, RelatorioEncomendasResponse } from '../types';

export const useRelatorioVendas = (dataInicio: string, dataFim: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['relatorios', 'vendas', dataInicio, dataFim],
    queryFn: async () => {
      const response = await api.get<RelatorioVendasResponse>('/relatorios/vendas', {
        params: {
          dataInicio,
          dataFim,
        },
      });
      return response.data;
    },
    enabled: enabled && !!dataInicio && !!dataFim,
    staleTime: 300000, // Data is fresh for 5 minutes
  });
};

export const useRelatorioEncomendas = (dataInicio: string, dataFim: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['relatorios', 'encomendas', dataInicio, dataFim],
    queryFn: async () => {
      const response = await api.get<RelatorioEncomendasResponse>('/relatorios/encomendas', {
        params: {
          dataInicio,
          dataFim,
        },
      });
      return response.data;
    },
    enabled: enabled && !!dataInicio && !!dataFim,
    staleTime: 300000, // Data is fresh for 5 minutes
  });
};
